import React, { useContext }  from 'react';
import { Box, Divider, Typography  } from '@mui/material';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses }  from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { Context} from '../../store/Context';

function OrderDetails({ state }) {	

    const { contextState: { orders: o, totalAmount, currencyIcon } }  = useContext( Context );

    let totalVat = 0;
    let price = totalAmount - totalVat.toFixed(2);
    o.forEach( order => totalVat += order.vat);    

    // format for display
    price = parseFloat(price).toFixed(2);
    totalVat = parseFloat(totalVat).toFixed(2);
    const t = parseFloat(totalAmount).toFixed(2);

   
	return (
        <Box>          
            <Divider variant="fullwidth" sx={{ mt:2, mb:2, height: 10, background: '#1976d2'}}/>
            <Typography component="h5" color="black" style={{ fontWeight: 600, textAlign: 'center' }}>
                Order Details
            </Typography>           
            <TableContainer component={Paper}>
                <Table sx={{ [`& .${tableCellClasses.root}`]: { borderBottom: "none" } }}>
                <TableBody>
                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 }}}>
                        <TableCell component="th" scope="row" sx={{ color: 'black', fontWeight: 400 }} style={{ width: '60%' }}>
                            Price
                        </TableCell>
                        <TableCell align="right" sx={{ fontWeight: 600}}>{currencyIcon} {price}</TableCell>
                    </TableRow>
                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                        <TableCell component="th" scope="row" sx={{ color: 'blue', fontWeight: 400 }} style={{ width: '60%' }}>
                            Delivery Charges
                        </TableCell>
                        <TableCell align="right" sx={{color: 'green', fontWeight: 400}}>Free</TableCell>
                    </TableRow>
                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                        <TableCell component="th" scope="row" sx={{ color: 'blue', fontWeight: 400 }} style={{ width: '60%' }}>
                            Discount Price
                        </TableCell>
                        <TableCell align="right" sx={{color: 'green', fontWeight: 400}}>None</TableCell>
                    </TableRow>
                     <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                        <TableCell component="th" scope="row" sx={{ color: 'blue', fontWeight: 400 }} style={{ width: '60%' }}>
                            VAT
                        </TableCell>
                        <TableCell align="right" sx={{color: 'green', fontWeight: 700}}>{currencyIcon} {totalVat}</TableCell>
                    </TableRow>
                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                        <TableCell component="th" scope="row" sx={{ color: 'black', fontWeight: 700 }} style={{ width: '60%' }}>
                            Total Amount
                        </TableCell>
                        <TableCell align="right" sx={{color: 'green', fontWeight: 700}}>{currencyIcon} {t}</TableCell>
                    </TableRow>
                </TableBody>
                </Table>
            </TableContainer>           
        </Box>
    );
}

export default OrderDetails;